import React from 'react';
import './AdminTableAnswers.scss';
//import {printQuizesCategory} from "../../../../../utils/helps.js";
import TableAnswers from './TableAnswers/TableAnswers';
import { openAddInputFormsForAnswers  } from '../../../adminSlice';

export default class AdminTableAnswers extends React.Component {
    constructor(props) {
        super(props);
        
        this.onAdd = this.onAdd.bind(this);
    }

    onAdd() {
        const { dispatch } = this.props;
    
        dispatch(openAddInputFormsForAnswers());
    
    }
    render() {
        let style;
       // console.log(this.props.adminState.dataSubCategoryId.length);
        if (this.props.adminState.selectedQuestion) {
          
                style = ''
            } else {
                style = 'disabled'
            }

        const { dispatch} = this.props;
        return (
            
            <div className="AdminTableAnswers">
                   <p className='tableName'>Список ответов {this.props.adminState.selectedQuestion} вопроса</p>

                   <TableAnswers 
                   dispatch={dispatch}
                   data={this.props.adminState.dataAnswersId}
                   />

                   <button className='addButton' onClick={this.onAdd} disabled={style}>{/*<i className="fas fa-plus"></i>*/}</button> 

                    


                
            </div>
        )
    }
}